export default "__VITE_ASSET__eFnHk6bS__"